export default __webpack_public_path__ + "static/media/invesrore.393ff758.png";